"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
var Subscription_1 = require("rxjs/Subscription");
var bidi_1 = require("@angular/cdk/bidi");
var operators_1 = require("rxjs/operators");
var scrollable_1 = require("../scrollable/scrollable");
var virtual_scroll_strategy_1 = require("../virtual-scroll-strategy/virtual-scroll-strategy");
var scroll_dispatcher_1 = require("../scroll-dispatcher/scroll-dispatcher");
var viewport_ruler_1 = require("../viewport-ruler/viewport-ruler");
require("./sis-virtual-scroll-viewport.component.css");
var Rx_1 = require("rxjs/Rx");
var animationFrameScheduler = Rx_1.Scheduler.animationFrame;
var asapScheduler = Rx_1.Scheduler.asap;
/**
 * Scheduler to be used for scroll events. Needs to fall back to
 * something that doesn't rely on requestAnimationFrame on environments
 * that don't support it (e.g. server-side rendering).
 */
var SCROLL_SCHEDULER = typeof requestAnimationFrame !== 'undefined'
    ? animationFrameScheduler
    : asapScheduler;
/** Checks if the given ranges are equal. */
function rangesEqual(r1, r2) {
    return r1.start == r2.start && r1.end == r2.end;
}
var SisVirtualScrollViewportComponent = /** @class */ (function (_super) {
    __extends(SisVirtualScrollViewportComponent, _super);
    function SisVirtualScrollViewportComponent(elementRef, _changeDetectorRef, ngZone, _scrollStrategy, dir, scrollDispatcher, viewportRuler) {
        var _this = _super.call(this, elementRef, scrollDispatcher, ngZone, dir) || this;
        _this.elementRef = elementRef;
        _this._changeDetectorRef = _changeDetectorRef;
        _this.ngZone = ngZone;
        _this._scrollStrategy = _scrollStrategy;
        _this.scrollDispatcher = scrollDispatcher;
        _this.viewportRuler = viewportRuler;
        /** Emits when the viewport is detached from a SisVirtualForOf. */
        _this._detachedSubject = new Subject_1.Subject();
        /** Emits when the rendered range changes. */
        _this._renderedRangeSubject = new Subject_1.Subject();
        _this._orientation = 'vertical';
        _this.hasViewportClass = true;
        _this.scrolledIndexChange = new Observable_1.Observable(function (observer) {
            return _this._scrollStrategy.scrolledIndexChange
                .subscribe(function (index) {
                return Promise.resolve()
                    .then(function () { return _this.ngZone.run(function () { return observer.next(index); }); });
            });
        });
        /** A stream that emits whenever the rendered range changes. */
        _this.renderedRangeStream = _this._renderedRangeSubject;
        /**
         * The total size of all content (in pixels), including content that is not currently rendered.
         */
        _this._totalContentSize = 0;
        /** A string representing the `style.width` property value to be used for the spacer element. */
        _this._totalContentWidth = '';
        /** A string representing the `style.height` property value to be used for the spacer element. */
        _this._totalContentHeight = '';
        /** The currently rendered range of indices. */
        _this._renderedRange = { start: 0, end: 0 };
        /** The length of the data bound to this viewport (in number of items). */
        _this._dataLength = 0;
        /** The size of the viewport (in pixels). */
        _this._viewportSize = 0;
        /** The last rendered content offset that was set. */
        _this._renderedContentOffset = 0;
        /**
         * Whether the last rendered content offset was to the end of the content (and therefore needs to
         * be rewritten as an offset to the start of the content).
         */
        _this._renderedContentOffsetNeedsRewrite = false;
        /** Whether there is a pending change detection cycle. */
        _this._isChangeDetectionPending = false;
        /** A list of functions to run after the next change detection cycle. */
        _this._runAfterChangeDetection = [];
        /** Subscription to changes in the viewport size. */
        _this._viewportChanges = Subscription_1.Subscription.EMPTY;
        if (!_scrollStrategy && (typeof ngDevMode === 'undefined' || ngDevMode)) {
            throw Error('Error: sis-virtual-scroll-viewport requires the "itemSize" property to be set.');
        }
        _this._viewportChanges = viewportRuler.change().subscribe(function () {
            _this.checkViewportSize();
        });
        return _this;
    }
    SisVirtualScrollViewportComponent_1 = SisVirtualScrollViewportComponent;
    Object.defineProperty(SisVirtualScrollViewportComponent.prototype, "orientation", {
        /** The direction the viewport scrolls. */
        get: function () {
            return this._orientation;
        },
        set: function (orientation) {
            if (this._orientation !== orientation) {
                this._orientation = orientation;
                this._calculateSpacerSize();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisVirtualScrollViewportComponent.prototype, "isHorizontal", {
        get: function () { return this._orientation === 'horizontal'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisVirtualScrollViewportComponent.prototype, "isVertical", {
        get: function () { return this._orientation !== 'horizontal'; },
        enumerable: true,
        configurable: true
    });
    SisVirtualScrollViewportComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.ngZone.runOutsideAngular(function () { return Promise.resolve().then(function () {
            _this._measureViewportSize();
            _this._scrollStrategy.attach(_this);
            _this.elementScrolled()
                .pipe(
            // Start off with a fake scroll event so we properly detect our initial position.
            operators_1.startWith(null), 
            // Collect multiple events into one until the next animation frame. This way if
            // there are multiple scroll events in the same frame we only need to recheck
            // our layout once.
            operators_1.auditTime(0, SCROLL_SCHEDULER))
                .subscribe(function () { return _this._scrollStrategy.onContentScrolled(); });
            _this._markChangeDetectionNeeded();
        }); });
    };
    SisVirtualScrollViewportComponent.prototype.ngOnDestroy = function () {
        this.detach();
        this._scrollStrategy.detach();
        // Complete all subjects
        this._renderedRangeSubject.complete();
        this._detachedSubject.complete();
        this._viewportChanges.unsubscribe();
        _super.prototype.ngOnDestroy.call(this);
    };
    /** Attaches a `SisVirtualScrollRepeater` to this viewport. */
    SisVirtualScrollViewportComponent.prototype.attach = function (forOf) {
        var _this = this;
        if (this._forOf && (typeof ngDevMode === 'undefined' || ngDevMode)) {
            throw Error('SisVirtualScrollViewportComponent is already attached.');
        }
        // Subscribe to the data stream of the SisVirtualForOf to keep track of when the data length
        // changes. Run outside the zone to avoid triggering change detection, since we're managing the
        // change detection loop ourselves.
        this.ngZone.runOutsideAngular(function () {
            _this._forOf = forOf;
            _this._forOf.dataStream.pipe(operators_1.takeUntil(_this._detachedSubject)).subscribe(function (data) {
                var newLength = data.length;
                if (newLength !== _this._dataLength) {
                    _this._dataLength = newLength;
                    _this._scrollStrategy.onDataLengthChanged();
                }
                _this._doChangeDetection();
            });
        });
    };
    /** Detaches the current `SisVirtualForOf`. */
    SisVirtualScrollViewportComponent.prototype.detach = function () {
        this._forOf = null;
        this._detachedSubject.next();
    };
    /** Gets the length of the data bound to this viewport (in number of items). */
    SisVirtualScrollViewportComponent.prototype.getDataLength = function () {
        return this._dataLength;
    };
    /** Gets the size of the viewport (in pixels). */
    SisVirtualScrollViewportComponent.prototype.getViewportSize = function () {
        return this._viewportSize;
    };
    /** Get the current rendered range of items. */
    SisVirtualScrollViewportComponent.prototype.getRenderedRange = function () {
        return this._renderedRange;
    };
    /**
     * Sets the total size of all content (in pixels), including content that is not currently
     * rendered.
     */
    SisVirtualScrollViewportComponent.prototype.setTotalContentSize = function (size) {
        if (this._totalContentSize !== size) {
            this._totalContentSize = size;
            this._calculateSpacerSize();
            this._markChangeDetectionNeeded();
        }
    };
    /** Sets the currently rendered range of indices. */
    SisVirtualScrollViewportComponent.prototype.setRenderedRange = function (range) {
        var _this = this;
        if (!rangesEqual(this._renderedRange, range)) {
            this._renderedRangeSubject.next(this._renderedRange = range);
            this._markChangeDetectionNeeded(function () { return _this._scrollStrategy.onContentRendered(); });
        }
    };
    /**
     * Gets the offset from the start of the viewport to the start of the rendered data (in pixels).
     */
    SisVirtualScrollViewportComponent.prototype.getOffsetToRenderedContentStart = function () {
        return this._renderedContentOffsetNeedsRewrite ? null : this._renderedContentOffset;
    };
    /**
     * Sets the offset from the start of the viewport to either the start or end of the rendered data
     * (in pixels).
     */
    SisVirtualScrollViewportComponent.prototype.setRenderedContentOffset = function (offset, to) {
        var _this = this;
        if (to === void 0) { to = 'to-start'; }
        // For a horizontal viewport in a right-to-left language we need to translate along the x-axis
        // in the negative direction.
        var isRtl = this.dir && this.dir.value == 'rtl';
        var isHorizontal = this.orientation == 'horizontal';
        var axis = isHorizontal ? 'X' : 'Y';
        var axisDirection = isHorizontal && isRtl ? -1 : 1;
        var transform = "translate" + axis + "(" + Number(axisDirection * offset) + "px)";
        this._renderedContentOffset = offset;
        if (to === 'to-end') {
            transform += " translate" + axis + "(-100%)";
            // The viewport should rewrite this as a `to-start` offset on the next render cycle. Otherwise
            // elements will appear to expand in the wrong direction (e.g. `mat-expansion-panel` would
            // expand upward).
            this._renderedContentOffsetNeedsRewrite = true;
        }
        if (this._renderedContentTransform != transform) {
            // We know this value is safe because we parse `offset` with `Number()` before passing it
            // into the string.
            this._renderedContentTransform = transform;
            this._markChangeDetectionNeeded(function () {
                if (_this._renderedContentOffsetNeedsRewrite) {
                    _this._renderedContentOffset -= _this.measureRenderedContentSize();
                    _this._renderedContentOffsetNeedsRewrite = false;
                    _this.setRenderedContentOffset(_this._renderedContentOffset);
                }
                else {
                    _this._scrollStrategy.onRenderedOffsetChanged();
                }
            });
        }
    };
    /**
     * Scrolls to the given offset from the start of the viewport. Please note that this is not always
     * the same as setting `scrollTop` or `scrollLeft`. In a horizontal viewport with right-to-left
     * direction, this would be the equivalent of setting a fictional `scrollRight` property.
     * @param offset The offset to scroll to.
     * @param behavior The ScrollBehavior to use when scrolling. Default is behavior is `auto`.
     */
    SisVirtualScrollViewportComponent.prototype.scrollToOffset = function (offset, behavior) {
        if (behavior === void 0) { behavior = 'auto'; }
        var options = { behavior: behavior };
        if (this.orientation === 'horizontal') {
            options.start = offset;
        }
        else {
            options.top = offset;
        }
        this.scrollTo(options);
    };
    /**
     * Scrolls to the offset for the given index.
     * @param index The index of the element to scroll to.
     * @param behavior The ScrollBehavior to use when scrolling. Default is behavior is `auto`.
     */
    SisVirtualScrollViewportComponent.prototype.scrollToIndex = function (index, behavior) {
        if (behavior === void 0) { behavior = 'auto'; }
        this._scrollStrategy.scrollToIndex(index, behavior);
    };
    /**
     * Gets the current scroll offset from the start of the viewport (in pixels).
     * @param from The edge to measure the offset from. Defaults to 'top' in vertical mode and 'start'
     *     in horizontal mode.
     */
    SisVirtualScrollViewportComponent.prototype.measureScrollOffset = function (from) {
        return from ?
            _super.prototype.measureScrollOffset.call(this, from) :
            _super.prototype.measureScrollOffset.call(this, this.orientation === 'horizontal' ? 'start' : 'top');
    };
    /** Measure the combined size of all of the rendered items. */
    SisVirtualScrollViewportComponent.prototype.measureRenderedContentSize = function () {
        var contentEl = this._contentWrapper.nativeElement;
        return this.orientation === 'horizontal' ? contentEl.offsetWidth : contentEl.offsetHeight;
    };
    /**
     * Measure the total combined size of the given range. Throws if the range includes items that are
     * not rendered.
     */
    SisVirtualScrollViewportComponent.prototype.measureRangeSize = function (range) {
        if (!this._forOf) {
            return 0;
        }
        return this._forOf.measureRangeSize(range, this.orientation);
    };
    /** Update the viewport dimensions and re-render. */
    SisVirtualScrollViewportComponent.prototype.checkViewportSize = function () {
        this._measureViewportSize();
        this._scrollStrategy.onDataLengthChanged();
    };
    /** Measure the viewport size. */
    SisVirtualScrollViewportComponent.prototype._measureViewportSize = function () {
        var viewportEl = this.elementRef.nativeElement;
        this._viewportSize = this.orientation === 'horizontal' ?
            viewportEl.clientWidth : viewportEl.clientHeight;
    };
    /** Queue up change detection to run. */
    SisVirtualScrollViewportComponent.prototype._markChangeDetectionNeeded = function (runAfter) {
        var _this = this;
        if (runAfter) {
            this._runAfterChangeDetection.push(runAfter);
        }
        // Use a Promise to batch together calls to `_doChangeDetection`. This way if we set a bunch of
        // properties sequentially we only have to run `_doChangeDetection` once at the end.
        if (!this._isChangeDetectionPending) {
            this._isChangeDetectionPending = true;
            this.ngZone.runOutsideAngular(function () { return Promise.resolve().then(function () {
                _this._doChangeDetection();
            }); });
        }
    };
    /** Run change detection. */
    SisVirtualScrollViewportComponent.prototype._doChangeDetection = function () {
        var _this = this;
        this._isChangeDetectionPending = false;
        // Apply the content transform. The transform can't be set via an Angular binding because
        // bypassSecurityTrustStyle is banned in Google. However the value is safe, it's composed of
        // string literals, a variable that can only be 'X' or 'Y', and user input that is run through
        // the `Number` function first to coerce it to a numeric value.
        this._contentWrapper.nativeElement.style.transform = this._renderedContentTransform;
        // Apply changes to Angular bindings. Note: We must call `markForCheck` to run change detection
        // from the root, since the repeated items are content projected in. Calling `detectChanges`
        // instead does not properly check the projected content.
        this.ngZone.run(function () { return _this._changeDetectorRef.markForCheck(); });
        var runAfterChangeDetection = this._runAfterChangeDetection;
        this._runAfterChangeDetection = [];
        for (var _i = 0, runAfterChangeDetection_1 = runAfterChangeDetection; _i < runAfterChangeDetection_1.length; _i++) {
            var fn = runAfterChangeDetection_1[_i];
            fn();
        }
    };
    /** Calculates the `style.width` and `style.height` for the spacer element. */
    SisVirtualScrollViewportComponent.prototype._calculateSpacerSize = function () {
        this._totalContentHeight =
            this.orientation === 'horizontal' ? '' : this._totalContentSize + "px";
        this._totalContentWidth =
            this.orientation === 'horizontal' ? this._totalContentSize + "px" : '';
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [String])
    ], SisVirtualScrollViewportComponent.prototype, "orientation", null);
    __decorate([
        core_1.HostBinding('class.sis-virtual-scroll-orientation-horizontal'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SisVirtualScrollViewportComponent.prototype, "isHorizontal", null);
    __decorate([
        core_1.HostBinding('class.sis-virtual-scroll-orientation-vertical'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SisVirtualScrollViewportComponent.prototype, "isVertical", null);
    __decorate([
        core_1.HostBinding('class.sis-virtual-scroll-viewport'),
        __metadata("design:type", Boolean)
    ], SisVirtualScrollViewportComponent.prototype, "hasViewportClass", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Observable_1.Observable)
    ], SisVirtualScrollViewportComponent.prototype, "scrolledIndexChange", void 0);
    __decorate([
        core_1.ViewChild('contentWrapper', { read: core_1.ElementRef }),
        __metadata("design:type", core_1.ElementRef)
    ], SisVirtualScrollViewportComponent.prototype, "_contentWrapper", void 0);
    SisVirtualScrollViewportComponent = SisVirtualScrollViewportComponent_1 = __decorate([
        core_1.Component({
            
            selector: 'sis-virtual-scroll-viewport',
            template: require('./sis-virtual-scroll-viewport.component.html'),
            encapsulation: core_1.ViewEncapsulation.None,
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
            providers: [{
                    provide: scrollable_1.SisScrollable,
                    useExisting: SisVirtualScrollViewportComponent_1
                }]
        }),
        __param(3, core_1.Optional()), __param(3, core_1.Inject(virtual_scroll_strategy_1.VIRTUAL_SCROLL_STRATEGY)),
        __param(4, core_1.Optional()),
        __metadata("design:paramtypes", [core_1.ElementRef,
            core_1.ChangeDetectorRef,
            core_1.NgZone, Object, bidi_1.Directionality,
            scroll_dispatcher_1.ScrollDispatcher,
            viewport_ruler_1.ViewportRuler])
    ], SisVirtualScrollViewportComponent);
    return SisVirtualScrollViewportComponent;
    var SisVirtualScrollViewportComponent_1;
}(scrollable_1.SisScrollable));
exports.SisVirtualScrollViewportComponent = SisVirtualScrollViewportComponent;
//# sourceMappingURL=sis-virtual-scroll-viewport.component.js.map